/* gvb-auto.js · behaviour for the default product page sections (gvb-auto-details, gvb-auto-related).
   - "Read more" on a clamped description ([data-au-more] → aria-controls target gets .is-open)
   - image strip viewer: <dialog data-au-lb> opened from .au-shot buttons inside [data-au-gallery]
   - tab switch between "Pairs well with" and "More in …" ([data-au-tabs] [role=tab])
   Delegated on document, so sections re-rendered in the theme editor keep working. */
(() => {
  if (window.__gvbAuto) return;
  window.__gvbAuto = true;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- read more ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-au-more]');
    if (!btn) return;
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const lbl = btn.querySelector('[data-au-more-label]');
    if (lbl) lbl.textContent = open ? (btn.dataset.less || 'Show less') : (btn.dataset.more || 'Read more');
    if (!open) {
      const top = box.getBoundingClientRect().top;
      if (top < 0) box.scrollIntoView({ block: 'start', behavior: reduce() ? 'auto' : 'smooth' });
    }
  });

  /* ---------- image viewer ---------- */
  let lb = null, shots = [], idx = 0, opener = null;
  const show = (i) => {
    if (!lb || !shots.length) return;
    idx = (i + shots.length) % shots.length;
    const s = shots[idx];
    const img = lb.querySelector('[data-au-lb-img]');
    img.width = +s.dataset.w || 1;
    img.height = +s.dataset.h || 1;
    img.src = s.dataset.auShot;
    const inner = s.querySelector('img');
    img.alt = inner ? inner.alt : '';
    const c = lb.querySelector('[data-au-lb-count]');
    if (c) c.textContent = (idx + 1) + ' / ' + shots.length;
    const multi = shots.length > 1;
    lb.querySelectorAll('[data-au-lb-prev],[data-au-lb-next]').forEach((b) => { b.hidden = !multi; });
  };
  document.addEventListener('click', (e) => {
    const shot = e.target.closest('.au-shot');
    if (shot) {
      const gal = shot.closest('[data-au-gallery]');
      lb = gal && gal.querySelector('[data-au-lb]');
      if (!lb || typeof lb.showModal !== 'function') return;
      shots = Array.from(gal.querySelectorAll('.au-shot'));
      opener = shot;
      show(shots.indexOf(shot));
      lb.showModal();
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    if (!lb || !lb.open) return;
    if (e.target.closest('[data-au-lb-close]') || e.target === lb) { lb.close(); return; }
    if (e.target.closest('[data-au-lb-prev]')) show(idx - 1);
    else if (e.target.closest('[data-au-lb-next]')) show(idx + 1);
  });
  document.addEventListener('keydown', (e) => {
    if (!lb || !lb.open) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
  });
  document.addEventListener('close', (e) => {
    if (!e.target.matches || !e.target.matches('[data-au-lb]')) return;
    document.documentElement.style.overflow = '';
    if (opener) opener.focus();
  }, true);
  /* swipe in the viewer */
  let x0 = null;
  document.addEventListener('touchstart', (e) => { if (lb && lb.open && lb.contains(e.target)) x0 = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', (e) => {
    if (x0 === null || !lb || !lb.open) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* ---------- tabs ---------- */
  const select = (tab, focus) => {
    const list = tab.closest('[role=tablist]');
    const sec = tab.closest('[data-au-tabs]');
    const tabs = Array.from(list.querySelectorAll('[role=tab]'));
    tabs.forEach((t, i) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      const p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
      sec.querySelectorAll('[data-au-tab-link="' + (i + 1) + '"]').forEach((a) => { a.hidden = !on; });
      if (on && p && window.GVB && window.GVB.updateRails) window.GVB.updateRails(p);
    });
    if (focus) tab.focus();
  };
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-au-tabs] [role=tab]');
    if (tab) select(tab, false);
  });
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest && e.target.closest('[data-au-tabs] [role=tab]');
    if (!tab) return;
    const tabs = Array.from(tab.closest('[role=tablist]').querySelectorAll('[role=tab]'));
    let i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i += 1;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i -= 1;
    else if (e.key === 'Home') i = 0;
    else if (e.key === 'End') i = tabs.length - 1;
    else return;
    e.preventDefault();
    select(tabs[(i + tabs.length) % tabs.length], true);
  });
})();
